import { deepClone } from '@/views/form/utils/index'
import { getToken } from '@/utils/auth'
import FileViewer from '@/views/form/components/file.vue'
import { uploadFiles } from '@/api/common'
import { cloneDeep } from 'lodash'
import { Message } from 'element-ui'
const componentChild = {}
/**
 * 将./slots中的文件挂载到对象componentChild上
 * 文件名为key，对应JSON配置中的bpmConfig.tag
 * 文件内容为value，解析JSON配置中的bpmSlot
 */
const slotsFiles = require.context('./slots', false, /\.js$/)
const keys = slotsFiles.keys() || []
keys.forEach(key => {
  const tag = key.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = slotsFiles(key).default
  componentChild[tag] = value
})
// 不限制整数
// function dealLimitIntNumber2(value) {
//   if (!value && value !== 0) return undefined
//   let data = String(value)
//   data = data.replace(/[^\d]/g, '') // 清除“数字”以外的字符
//   // 截取以0为开头的数据
//   // if (data.length > 1 && data.startsWith('0')) {
//   //   data = data.substring(1)
//   // }
//   value = Number(data)
//   return Number(data)
// }
// 对整数类型限制处理
// function dealLimitIntNumber(value) {
//   if (!value && value !== 0) return undefined
//   let data = String(value)
//   data = data.replace(/[^\d]/g, '') // 清除“数字”以外的字符
//   // 截取以0为开头的数据
//   if (data.length > 1 && data.startsWith('0')) {
//     data = data.substring(1)
//   }
//   value = Number(data)
//   return Number(data)
// }
// 触发父级校验
const dispatch = function(componentName, comp, config) {
  var parent = comp.$parent || comp.$root
  var name = parent.$options.componentName
  while (parent && (!name || name !== componentName)) {
    parent = parent.$parent
    if (parent) {
      name = parent.$options.componentName
    }
  }
  if (parent) {
    parent.validGeneratorForm(config.vModel)
  }
}
function vModel(dataObject, defaultValue, confClone) {
  const type = confClone['compType']
  dataObject.props.value = defaultValue
  if (type === 13) {
    dataObject.props.value = Number(defaultValue)
  }
  if (type === 14 || type === 15) {
    dataObject.props.fileList = cloneDeep(defaultValue)
  }
  // 计数器输入响应处理
  if (type === 3) {
    // 计数器input时间
    dataObject.nativeOn.input = (val) => {
      if (val.target.value === '') {
        this.$emit('input', undefined)
      } else {
        const inputValue = Number(val.target.value)
        // console.log('inputValue', inputValue)
        // val.target.value = dealLimitIntNumber2(val.target.value) === undefined ? undefined : dealLimitIntNumber2(val.target.value)
        this.$emit('input', inputValue || inputValue === 0 ? inputValue : undefined)
        if (inputValue > 999999999999999) {
          Message.error('数字内容过大，请调整')
          val.target.value = undefined
          this.$emit('input', undefined)
        }
        if (inputValue < -999999999999999) {
          Message.error('数字内容过小，请调整')
          val.target.value = undefined
          this.$emit('input', undefined)
        }
      }

      this.$nextTick(() => {
        this.$forceUpdate()
      })
    }
    dataObject.on.input = val => {
      // console.log('val2', val)
      this.$emit('input', val || val === 0 ? val : undefined)
      if (val > 999999999999999) {
        this.$emit('input', undefined)
        Message.error('数字内容过大，请调整')
      }
      if (val < -999999999999999) {
        Message.error('数字内容过小，请调整')
        this.$emit('input', undefined)
      }
      this.$nextTick(() => {
        this.$forceUpdate()
      })
    }
  } else {
    dataObject.on.input = val => {
      if (type === 1 || type === 2) {
        this.$emit('input', val ? val.replace(/(^\u0020*)|(\u0020*$)/g, '') : val)
        // this.$emit('input', val ? val.replace(/(^\s*)|(\s*$)/g, '') : val)
      } else {
        this.$emit('input', val)
      }
      if (type === 14 || type === 15 || type === 16 || type === 17 || type === 18) {
        dispatch('ParserGeneratorForm', this, confClone)
      }
      const deptsType = [16, 17, 18]
      if (!deptsType.includes(type)) {
        this.$nextTick(() => {
          this.$forceUpdate()
        })
      }
    }
  }
  // dataObject.props.value = (defaultValue === undefined || defaultValue === null || Array.isArray(defaultValue)) ? defaultValue : defaultValue
}

function mountSlotFiles(h, confClone, children) {
  const childObjs = componentChild[confClone.bpmConfig.tag]
  if (childObjs) {
    Object.keys(childObjs).forEach(key => {
      const childFunc = childObjs[key]
      if (confClone.bpmSlot && confClone.bpmSlot[key]) {
        children.push(childFunc(h, confClone, key))
      }
    })
  }
}

function emitEvents(confClone) {
  ['on', 'nativeOn'].forEach(attr => {
    const eventKeyList = Object.keys(confClone[attr] || {})
    eventKeyList.forEach(key => {
      const val = confClone[attr][key]
      if (typeof val === 'string') {
        confClone[attr][key] = event => this.$emit(val, event)
      }
    })
  })
}

function buildDataObject(confClone, dataObject) {
  Object.keys(confClone).forEach(key => {
    const val = confClone[key]
    if (key === 'vModel') {
      vModel.call(this, dataObject, confClone.bpmConfig.defaultValue, confClone)
    } else if (dataObject[key] !== undefined) {
      if (dataObject[key] === null ||
        dataObject[key] instanceof RegExp ||
        ['boolean', 'string', 'number', 'function'].includes(typeof dataObject[key])) {
        dataObject[key] = val
      } else if (Array.isArray(dataObject[key])) {
        dataObject[key] = [...dataObject[key], ...val]
      } else {
        dataObject[key] = { ...dataObject[key], ...val }
      }
    } else {
      dataObject.attrs[key] = val
    }
  })

  // 清理属性
  clearAttrs(dataObject)
}

function clearAttrs(dataObject) {
  delete dataObject.attrs.bpmConfig
  delete dataObject.attrs.bpmSlot
  delete dataObject.attrs.__methods__
}

function makeDataObject() {
  // 深入数据对象：
  // https://cn.vuejs.org/v2/guide/render-function.html#%E6%B7%B1%E5%85%A5%E6%95%B0%E6%8D%AE%E5%AF%B9%E8%B1%A1
  return {
    class: {},
    attrs: {},
    props: {},
    domProps: {},
    nativeOn: {},
    on: {},
    style: {},
    directives: [],
    scopedSlots: {},
    slot: null,
    key: null,
    ref: null,
    refInFor: true
  }
}

export default {
  props: {
    conf: {
      type: Object,
      required: true
    },
    isParse: {
      type: Boolean,
      default: false // 是否parse解析器解析
    },
    isText: {
      type: Boolean,
      default: false // 是否禁止编辑
    },
    isPrint: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: () => {}
    },
    processId: {
      type: String,
      default: ''
    },
    systemInfo: {
      type: Object,
      default: () => {} // 系统变量
    },
    field: { // 存在于明细表中则有field字段
      type: String,
      default: ''
    },
    fieldData: { // 存在于明细表中则有field字段，明细表某一行数据
      type: Object,
      default: () => {}
    },
    isEditHisotry: {
      type: Boolean, // 是否編輯記錄裏面
      default: false
    },
    isInTemplate: {
      type: Boolean, // 是否模板配置页面
      default: false
    }
  },
  render(h) {
    const dataObject = makeDataObject()
    dataObject.class['vModel_' + this.conf.vModel] = true
    const confClone = deepClone(this.conf)
    const children = this.$slots.default || []
    const tag = this?.conf?.bpmConfig?.tag
    const compType = this?.conf?.compType
    let defaultValue = this?.conf?.bpmConfig?.defaultValue
    // 如果slots文件夹存在与当前tag同名的文件，则执行文件中的代码
    mountSlotFiles.call(this, h, confClone, children)

    // 将字符串类型的事件，发送为消息
    emitEvents.call(this, confClone)

    // 将json表单配置转化为vue render可以识别的 “数据对象（dataObject）”
    buildDataObject.call(this, confClone, dataObject)
    let headers = {
      'S-Token': getToken()
    }
    if (this.$isInFrame) {
      headers = {
        'X-Token': getToken()
      }
    }
    const isConsole = sessionStorage.getItem('isConsole')
    if (isConsole) {
      headers = {
        'C-Token': getToken()
      }
    }
    if (this.$isInKa) {
      headers = {
        'sso-Token': getToken()
      }
    }
    const that = this
    if (!that.isParse) {
      dataObject.class['is-cursor-none'] = true
    }
    dataObject.props.conf = that.conf
    // 表单数据传递
    dataObject.props.isInTemplate = this.isInTemplate
    dataObject.props.formData = this.formData
    dataObject.props.processId = this.processId
    if (this.conf.bpmConfig.tag === 'el-upload') {
      // if (this.conf.accept !== 'image/*') {
      //   this.conf.compType = 15
      //   dataObject.props['list-type'] = 'text'
      //   children[0] = <el-button size='small' type='primary'>上传附件</el-button>
      // }
      if (this.conf.compType === 14) {
        this.conf.accept = '.png,.jpg,.jpeg,.gif'
        dataObject.props['accept'] = '.png,.jpg,.jpeg,.gif'
      } else if (this.conf.compType === 15) {
        this.conf.accept = '.png,.jpg,.jpeg,.gif,.pdf, .doc, .docx, .xls, .xlsx,.rar,.zip'
        dataObject.props['accept'] = '.png,.jpg,.jpeg,.gif,.pdf, .doc, .docx, .xls, .xlsx,.rar,.zip'
      }
      const settingSize = that.conf.bpmConfig.fileSize
      dataObject.props.headers = headers
      dataObject.props.action = process.env.VUE_APP_BASE_API + '/externalApplication/upload'
      dataObject.props.beforeUpload = function(file) {
        // console.log('file', file.type)
        const typeItem = file.name.split('.')
        const type = typeItem[typeItem.length - 1].toLowerCase()
        const allowType = that.conf.compType === 14 ? ['jpg', 'png', 'gif', 'jpeg'] : ['jpg', 'png', 'gif', 'jpeg', 'xls', 'xlsx', 'doc', 'docx', 'pdf', 'rar', 'zip']
        if (!allowType.includes(type)) {
          if (that.conf.compType === 14) {
            this.$message.error('仅支持jpg/png/gif/jpeg')
          } else {
            this.$message.error('仅支持jpg/png/gif/jpeg/xls/xlsx/doc/docx/pdf')
          }
          return false
        }
        const fileSize = file.size / 1024 / 1024
        // 限制文件上传大小
        if (fileSize > settingSize) {
          this.$message.error(`上传${that.conf && that.conf.compType === 14 ? '图片' : '附件'}大小不能超过 ${settingSize}M!`)
          return false
        }
        return true
      }
      dataObject.props.httpRequest = async function(file) {
        const formData = new FormData()
        formData.append('file', file.file)
        formData.append('source', 'bpm')
        const res = await uploadFiles(formData, headers, progressEvent => {
          const complete = parseInt(
            ((progressEvent.loaded / progressEvent.total) * 100) | 0,
            10
          )
          file.onProgress({ percent: complete })
        })
        if (res.code === 511) {
          this.$message.warning(res.message)
          return
        }
        if (res.code === 200 && res.data) {
          this.fileList.forEach((item) => {
            if (item.uid === file.file.uid) {
              item.url = res.data
            }
          })
          // const uploadFileList = this.fileList.filter((item) => item.url && item.url.startsWith('https'))
          // const submitList = uploadFileList.map((item) => {
          //   return {
          //     name: item.name,
          //     url: item.url
          //   }
          // })
          // that.$emit('input', submitList)
          // dispatch('ParserGeneratorForm', this, confClone)
        }
      }
      dataObject.props.onPreview = function(file) {
        this.$fileView.openFile(file)
      }
      dataObject.props.onChange = function(file, fileList) {
        const uploadAllFinished = fileList.every((item) => item.url && item.url.startsWith('https'))
        if (uploadAllFinished) {
          const submitList = fileList.map((item) => {
            return {
              name: item.name,
              url: item.url
            }
          })
          this.$emit('input', submitList)
          dispatch('ParserGeneratorForm', this, confClone)
        }
      }
      dataObject.props.onProgress = function(event, file) {
      }
      // dataObject.props.onSuccess = async function(res, file, fileList) {
      //   console.log('监听到了上传success----》', file, fileList)

      dataObject.props.onError = function(err, file, fileList) {
        console.log('err', err)
      }
      dataObject.props.onRemove = function(file, fileList) {
        const newFileList = fileList.map((item) => {
          return {
            name: item.name,
            url: item.response && item.response.data || item.url
          }
        })
        that.conf.bpmConfig.defaultValue = newFileList
        this.$emit('input', that.conf.bpmConfig.defaultValue)
        that.conf.bpmConfig.fileList = newFileList
        if (that.isParse) {
          dataObject.props.fileList = that.conf.bpmConfig.fileList ? that.conf.bpmConfig.fileList : []
        }
      }
    } else if (tag === 'my-person' || tag === 'my-role' || tag === 'my-department') {
      dataObject.props.title = this.conf.placeholder
      dataObject.props.showUsers = true
    } else if (tag === 'my-approve') {
      // console.log(this.conf, '-=-=-=this.conf--=my-approve')
      dataObject.props.approvalType = this.conf.bpmConfig.approvalType
    } else if (tag === 'my-statistics') {
      // console.log(this.conf, '-=-=-=this.conf--=my-statistics')
      dataObject.props.statisticsTmp = this.conf.bpmConfig.statisticsTmp
      dataObject.props.filterFields = this.conf.bpmConfig.filterFields
    } else if ([9, 10, 19, 20].includes(compType)) {
      // console.log('compType------>', compType, this.conf.bpmConfig)
      if (this.conf.bpmConfig.allowHistory === false) {
        // console.log('进入了这一步121313213')
        dataObject.props.pickerOptions = {
          disabledDate: (date) => {
            // 获取当前日期
            const today = new Date()
            // 将日期设置为当天的 00:00:00
            today.setHours(0, 0, 0, 0)
            // 将传入的日期设置为 00:00:00
            date.setHours(0, 0, 0, 0)

            // 如果传入的日期等于当天的日期，则禁止选择
            return date.getTime() < today.getTime()
          }
        }
      }
    } else if (this.conf.compType === 26) {
      dataObject.props.field = this.field
      dataObject.props.fieldData = this.fieldData
    } else if (that.conf.bpmConfig.tag === 'el-input' && this.conf.type !== 'textarea') {
      if (defaultValue && String(defaultValue).startsWith('unique-bpm-')) {
        // 获取组织信息进行赋值
        // that.conf.bpmConfig.defaultValue = 1
      }
    } else if (that.conf.bpmConfig.tag === 'my-system') {
      dataObject.props.systemVariable = this.conf.bpmConfig.systemVariable
    } else if (tag === 'my-form') {
      dataObject.props.children = this.conf.bpmConfig && this.conf.bpmConfig.children || []
      dataObject.props.type = this.conf.bpmConfig.direction || 'row'
    }
    if (this.conf.vModel) {
      dataObject.props.key = this.conf.vModel
    }
    // 系统变量
    dataObject.props.systemInfo = this.systemInfo
    // 根据场景判断渲染文本还是组件
    if (this.isEditHisotry || (this.isText && this.conf.isEditText !== true) || this.isPrint) {
      dataObject.props.disabled = true
      if (this.conf && this.conf.placeholder) {
        this.conf.placeholder = ''
        dataObject.props.placeholder = ''
      }
      const compList = [16, 17, 18] // 部分详情显示组件
      if (compType === 1) {
        return h('div', { class: { 'word-break': true }}, defaultValue || '--')
      } else if (compType === 2 && this.isPrint) {
        return h('div', { class: { 'textarea-print': true }}, defaultValue || '--')
      }
      if (compType === 14) {
        if (defaultValue.length === 0) {
          defaultValue = '--'
          return h('div', {}, defaultValue || '--')
        } else {
          // const imgList = defaultValue.map((item) => item.url)
          // return h('img-viewer', { props: { imgList }})
          dataObject.class['flow-upload-show'] = true
          return h(this.conf.bpmConfig.tag, dataObject, children)
        }
      } else if (compType === 15) {
      // 附件处理
        return h(FileViewer, { props: { fileList: defaultValue }})
      } else if (compList.includes(compType)) {
        if (defaultValue.length === 0) {
          defaultValue = '--'
          return h('div', {}, defaultValue || '--')
        } else {
          dataObject.props.isText = true
          return h(this.conf.bpmConfig.tag, dataObject, children)
        }
      }
      // if (compType === 3) {
      //   // 附件处理
      //   return h('div', {}, defaultValue || defaultValue === 0 ? defaultValue : '--')
      // } else if (selectCompList.includes(compType)) {
      //   const options = this?.conf?.bpmSlot?.options || []
      //   if (compType === 5 || compType === 6) {
      //     const value = []
      //     if (Array.isArray(defaultValue) && defaultValue.length > 0) {
      //       defaultValue.forEach((item) => {
      //         const defaultOptions = options.find((item2) => item2.value === item)
      //         if (defaultOptions) {
      //           value.push(defaultOptions.label)
      //         }
      //       })
      //       defaultValue = value.join('、')
      //     } else {
      //       defaultValue = '--'
      //     }
      //   } else {
      //     const defaultOptions = options.find((item) => item.value === defaultValue)
      //     if (defaultOptions.label) {
      //       defaultValue = defaultOptions.label
      //     }
      //   }
      //   return h('div', {}, defaultValue || '--')
      // } else if (compList.includes(compType)) {
      //   if (defaultValue.length === 0) {
      //     defaultValue = '--'
      //   } else {
      //     dataObject.props.isText = true
      //     return h(this.conf.bpmConfig.tag, dataObject, children)
      //   }
      // // 图片处理
      // } else if (compType === 14) {
      //   if (defaultValue.length === 0) {
      //     defaultValue = '--'
      //   } else {
      //     const imgList = defaultValue.map((item) => item.url)
      //     console.log('imgList', imgList)
      //     return h('img-viewer', { props: { imgList }})
      //   }
      // } else if (compType === 15) {
      // // 附件处理
      //   return h(FileViewer, { props: { fileList: defaultValue }})
      // } else if (compType === 12 || compType === 20 || compType === 10 && Array.isArray(defaultValue)) {
      //   console.log('defaultValue', defaultValue)
      //   if (defaultValue) {
      //     defaultValue = defaultValue.join(' ' + (this.conf['range-separator']) + ' ')
      //   } else {
      //     defaultValue = '--'
      //   }
      // } else if (Array.isArray(defaultValue)) {
      //   defaultValue = defaultValue.join('、')
      // }
      // return h('div', {}, defaultValue || '--')
    }
    return h(this.conf.bpmConfig.tag, dataObject, children)
  }
}
